import React from 'react';
import { Flex } from '@/ui/layout';
import { useTranslation, withTranslation } from 'react-i18next';
import { default as PhoneInputWithCountry } from 'react-phone-number-input/react-hook-form';
import 'react-phone-number-input/style.css';
import { Body4 } from '@/ui/typography';
import { getLocalizedText } from '@/utils/helpers';
import { Label } from '@/components';

export const PhoneInput = withTranslation()(({
  t,
  tooltip,
  tooltip_RU,
  tooltip_LV,
  value,
  setValue,
  marginBottom,
  marginTopLabel,
  label = t('Phone number'),
  required,
  error,
  disabled,
  name,
  control,
  wide,
  layout,
  boldLabel
}) => {
  const { i18n } = useTranslation();

  return (
    <div style={{ textAlign: 'left', width: wide ? '100%' : 'auto' }}>
      <Flex vertical $marginTop={marginTopLabel} $marginBottom={marginBottom}>
        <Label
          label={label}
          required={required}
          tooltip={
            tooltip
              ? getLocalizedText(
                  {
                    tooltip: tooltip,
                    tooltip_RU: tooltip_RU,
                    tooltip_LV: tooltip_LV
                  },
                  'tooltip',
                  i18n
                )
              : null
          }
          layout={layout}
          bold={boldLabel}
        >
          <PhoneInputWithCountry
            international
            name={name}
            control={control}
            rules={{ required: required }}
            disabled={disabled}
            value={value}
            onChange={setValue}
          />
        </Label>
      </Flex>
      {error && (
        <Body4 $marginTop={8} $color={'#FF424F'}>
          {t('Required')}
        </Body4>
      )}
    </div>
  );
});
